// 2_components/measure_units_show.js
// Shows the package size and computes a price-per-unit label for product cards and
// the product detail, using the measure-unit filter data
// (window.NAT.measureFiltersData) and per-language unit singularization.

// Per-language plural -> singular unit map, sourced from translations.
const singleMeasuringUnit = window.NAT.translations("measuringUnitSingulars");

export function init() {
	measureUnitFromFiltersProducts();
	document.addEventListener("ShoptetDOMContentLoaded", function (event) {
		measureUnitFromFiltersProducts();
	});
	document.addEventListener("luigiSearchDone", function (event) {
		measureUnitFromFiltersProducts();
	});

	document.addEventListener("dkLabFavouriteProductsLoaded", function () {
		measureUnitFromFiltersProducts();
	});

	if (document.body.classList.contains("type-product")) {
		document.addEventListener("priceAndButtonMoved", function (event) {
			measureUnitFromFiltersDetail();
		});
	}

	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", function () {
		measureUnitFromFiltersProducts();
	});
}

async function measureUnitFromFiltersProducts() {
	const allProductsInProductsBlock = document.querySelectorAll(".products-block .product");
	if (!allProductsInProductsBlock || allProductsInProductsBlock.length === 0) {
		return; // No products found
	}
	await window.NAT.utils.downloadAndSaveMeasureUnitFilter();
	const productFilterData = window.NAT.measureFiltersData;
	if (!productFilterData || productFilterData.length === 0) {
		return; // No filter data available
	}

	allProductsInProductsBlock.forEach((product) => {
		if (product.classList.contains("product-edited-measure")) {
			return; // Skip if already processed
		}
		product.classList.add("product-edited-measure");
		const productCodeForFilter = product.querySelector("span[data-micro='sku']")?.textContent.trim();
		if (!productCodeForFilter) {
			console.warn("Product code not found for a product.");
			return;
		}

		const amountText = productFilterData.find((item) => item.code === productCodeForFilter)?.value;
		if (!amountText) {
			console.warn("No measure unit found for product code:", productCodeForFilter);
			return;
		}

		// Convert comma to dot, then extract the number and unit
		const normalizedAmountText = amountText.replace(",", ".").trim();

		// Extract the numeric part (including decimal)
		const productMeasureAmount = normalizedAmountText.match(/[\d.]+/) ? normalizedAmountText.match(/[\d.]+/)[0] : "";

		// Extract the unit part (letters and spaces after the number)
		const productMeasureUnit = normalizedAmountText.replace(/[\d.\s]+/, "").trim();

		/* 	let productMeasureAmount = amountText.replace(/[^\d]/g, ""); //keep only digits from the measure unit
		let productMeasureUnit = amountText.replace(/[\d\s]/g, ""); //keep only letters from the measure unit
 */
		const ratingsWrapper = product.querySelector(".ratings-wrapper");
		if (ratingsWrapper) {
			// Create a new span element to display the amount
			const measureUnitSpan = document.createElement("span");
			measureUnitSpan.className = "product-measure-unit";
			measureUnitSpan.textContent = amountText;

			// Append the amount span to the ratings wrapper
			ratingsWrapper.appendChild(measureUnitSpan);
		}

		const pricePerUnitDiv = document.createElement("div");
		pricePerUnitDiv.className = "product-price-per-unit";
		const prices = product.querySelector(".prices");

		const priceFinal = product.querySelector(".price-final strong");
		let priceFinalValue;

		if (priceFinal) {
			// Extract the text content, trim it, and remove everything but numbers
			priceFinalValue = priceFinal.textContent.trim().replace(/[^\d.,]/g, ""); // Keep only digits, commas, and dots
			priceFinalValue = parseFloat(priceFinalValue.replace(",", ".")).toFixed(2);
		}

		let pricePerUnit_Unit;

		let foundUnitMatch = false;

		// Iterate over the keys in the object
		for (let key in singleMeasuringUnit) {
			if (productMeasureUnit.includes(key)) {
				foundUnitMatch = true;
				pricePerUnit_Unit = singleMeasuringUnit[key];
				break; // Exit the loop once a match is found
			}
		}
		if (!foundUnitMatch) {
			// If no match is found, use the original measure unit
			pricePerUnit_Unit = productMeasureUnit;
		}

		const pricePerUnit_Value = priceFinalValue / productMeasureAmount;

		const pricePerUnit_ValueSpan = document.createElement("span");
		pricePerUnit_ValueSpan.className = "product-price-per-unit-value";

		pricePerUnit_ValueSpan.textContent =
			pricePerUnit_Value.toFixed(2).replace(".", ",") + " " + window.NAT.translations("currencySymbol") + " / 1 " + pricePerUnit_Unit;

		if (prices && pricePerUnitDiv) {
			prices.appendChild(pricePerUnitDiv);
			pricePerUnitDiv.appendChild(pricePerUnit_ValueSpan);
		}
	});
}

async function measureUnitFromFiltersDetail() {
	const priceAndButtonWrapper = document.querySelector(".price-and-button-wrapper");
	if (!priceAndButtonWrapper) {
		return; // No products found
	}

	const sku = document.querySelector(".p-code > span:nth-child(2)")?.textContent.trim();
	if (!sku) {
		return; // No SKU found
	}
	await window.NAT.utils.downloadAndSaveMeasureUnitFilter();
	const productFilterData = window.NAT.measureFiltersData;
	if (!productFilterData || productFilterData.length === 0) {
		return; // No filter data available
	}

	const amountText = productFilterData.find((item) => item.code === sku)?.value;
	if (!amountText) {
		console.warn("No measure unit found for product code:", sku);
		return;
	}
	// Convert comma to dot, then extract the number and unit
	const normalizedAmountText = amountText.replace(",", ".").trim();

	// Extract the numeric part (including decimal)
	const productMeasureAmount = normalizedAmountText.match(/[\d.]+/) ? normalizedAmountText.match(/[\d.]+/)[0] : "";

	// Extract the unit part (letters and spaces after the number)
	const productMeasureUnit = normalizedAmountText.replace(/[\d.\s]+/, "").trim();

	const priceFinal = priceAndButtonWrapper.querySelector(".price-final");

	const priceFinalHolder = priceAndButtonWrapper.querySelector(".price-final-holder");
	let priceFinalValue;

	if (priceFinalHolder) {
		// Extract the text content, trim it, and remove everything but numbers
		priceFinalValue = priceFinalHolder.textContent.trim().replace(/[^\d.,]/g, ""); // Keep only digits, commas, and dots
		priceFinalValue = parseFloat(priceFinalValue.replace(",", ".")).toFixed(2);
	}

	let pricePerUnit_Unit;

	let foundUnitMatch = false;

	// Iterate over the keys in the object
	for (let key in singleMeasuringUnit) {
		if (productMeasureUnit.includes(key)) {
			foundUnitMatch = true;
			pricePerUnit_Unit = singleMeasuringUnit[key];
			break; // Exit the loop once a match is found
		}
	}
	if (!foundUnitMatch) {
		// If no match is found, use the original measure unit
		pricePerUnit_Unit = productMeasureUnit;
	}

	const pricePerUnit_Value = priceFinalValue / productMeasureAmount;

	const pricePerUnit_ValueSpan = document.createElement("span");
	pricePerUnit_ValueSpan.className = "product-price-per-unit-value";

	pricePerUnit_ValueSpan.textContent =
		pricePerUnit_Value.toFixed(2).replace(".", ",") + " " + window.NAT.translations("currencySymbol") + " / 1 " + pricePerUnit_Unit;

	const pricePerUnitDiv = document.createElement("div");
	pricePerUnitDiv.className = "product-price-per-unit";
	priceFinal.appendChild(pricePerUnitDiv);
	pricePerUnitDiv.appendChild(pricePerUnit_ValueSpan);
}
